import React, {useEffect, useRef} from "react";
import styled from "styled-components";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {Prediction} from "./Prediction";
import group_bg from "apps/DRAW_PREDICTOR/assets/images/group_bg.png";
import group_bg_mobile from "apps/DRAW_PREDICTOR/assets/images/group_bg_mobile.svg";
import predictionIcon from "apps/DRAW_PREDICTOR/assets/images/icons/prediction.svg";
import {media} from "assets/css/media";
import {useSelector} from "react-redux";
import {getAvailableGroupForPot1} from "apps/DRAW_PREDICTOR/modules/selectors";
import {useMediaQuery} from "modules";

const PredictionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 297px;
	height: 297px;
	background-image: url(${group_bg});
	padding: 15px 15px 0 15px;
	margin-top: 20px;

	@media (max-width: ${media.mobile}) {
		justify-content: flex-start;
		width: 340px;
		height: 215px;
		background-image: url(${group_bg_mobile});
	}
`;

const TitleWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	margin-bottom: 10px;

	@media (max-width: ${media.mobile}) {
		justify-content: space-between;
		margin-bottom: 16px;
	}
`;

const Title = styled.h5`
	font-family: "Qatar2022", sans-serif;
	font-weight: 700;
	font-size: 18px;
	color: #ae9142;
	text-align: center;
	background: -webkit-linear-gradient(-312.07deg, #ae9142 0%, #dfce6d 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	@media (max-width: ${media.mobile}) {
		font-size: 16px;
	}
`;

const PositionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1;

	@media (max-width: ${media.mobile}) {
		flex-direction: row;
		flex: 0 1 auto;
	}
`;

const PredictionIconDesktop = styled.div`
	//width: 71px;
	margin: 6px auto 12px auto;
	max-width: 100%;

	@media (max-width: ${media.mobile}) {
		display: none;
	}
`;

const PredictionIconMobile = styled.div`
	display: none;
	width: 50px;

	@media (max-width: ${media.mobile}) {
		display: inline;
		img {
			max-width: 100%;
		}
	}
`;

interface IProps {
	group: Groups;
	showMore: boolean;
}

export const GroupPredictions: React.FC<IProps> = ({group, showMore}) => {
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);
	const ref = useRef<HTMLDivElement>(null);
	const availableGroup = useSelector(getAvailableGroupForPot1);
	const isActive = availableGroup === group;
	const hideGroup = isMobile && !showMore && !isActive;
	const Positions = [1, 2, 3, 4];

	useEffect(() => {
		if (ref && isMobile && isActive) {
			ref.current?.scrollIntoView({
				block: "center",
			});
		}
	}, [isMobile, isActive]);

	if (hideGroup) {
		return null;
	}

	return (
		<PredictionWrapper ref={ref}>
			<TitleWrapper>
				<Title>Group {group.toUpperCase()}</Title>
				<PredictionIconMobile>
					<img src={predictionIcon} alt="icon" />
				</PredictionIconMobile>
			</TitleWrapper>
			<PositionWrapper>
				{Positions.map((pot) => (
					<Prediction group={group} position={pot} key={pot} />
				))}
			</PositionWrapper>
			<PredictionIconDesktop>
				<img src={predictionIcon} alt="icon" />
			</PredictionIconDesktop>
		</PredictionWrapper>
	);
};
